import type { VisitTypeOption } from '../../../../types';

export const visitTypeOptions: VisitTypeOption[] = [
  {
    children: [
      {
        children: [
          {
            name: 'Adult Medicine',
            translations: {
              en: 'Adult Medicine',
              es: 'Medicina para adultos',
            },
          },
          {
            name: 'Pediatric Medicine',
            translations: {
              en: 'Pediatric Medicine',
              es: 'Medicina Pediátrica',
            },
          },
          {
            name: "Women's Health",
            translations: {
              en: "Women's Health",
              es: 'La salud de la mujer',
            },
          },
          {
            name: 'Nephrology',
            translations: {
              en: 'Nephrology',
              es: 'Nefrología',
            },
          },
          {
            name: 'Cardiology',
            translations: {
              en: 'Cardiology',
              es: 'Cardiología',
            },
          },
          {
            name: 'Endocrinology',
            translations: {
              en: 'Endocrinology',
              es: 'Endocrinología',
            },
          },
          {
            name: 'Pulmonary',
            translations: {
              en: 'Pulmonary',
              es: 'Pulmonar',
            },
          },
          {
            name: 'Gastroenterology',
            translations: {
              en: 'Gastroenterology',
              es: 'Gastroenterología',
            },
          },
          {
            name: 'Infectious Disease',
            translations: {
              en: 'Infectious Disease',
              es: 'Enfermedad infecciosa',
            },
          },
          {
            name: 'Allergy and Immunology',
            translations: {
              en: 'Allergy and Immunology',
              es: 'Alergia e Inmunología',
            },
          },
          {
            name: 'Dermatology',
            translations: {
              en: 'Dermatology',
              es: 'Dermatología',
            },
          },
          {
            name: 'Rheumatology',
            translations: {
              en: 'Rheumatology',
              es: 'reumatología',
            },
          },
          {
            name: 'Neurology',
            translations: {
              en: 'Neurology',
              es: 'Neurología',
            },
          },
          {
            name: 'Ortho/Sports Medicine',
            translations: {
              en: 'Ortho/Sports Medicine',
              es: 'Ortopedia/Medicina Deportiva',
            },
          },
          {
            name: 'Occupational Medicine',
            translations: {
              en: 'Occupational Medicine',
              es: 'Medicina Ocupacional',
            },
          },
        ],
        name: 'General Medical/Episodic Care',
        translations: {
          en: 'General Medical/Episodic Care',
          es: 'Atención médica general/episódica',
        },
      },
      {
        name: 'HEDIS/Care Gap',
        translations: {
          en: 'HEDIS/Care Gap',
          es: 'HEDIS/brecha de atención',
        },
      },
      {
        name: 'Collaborative Care Management',
        translations: {
          en: 'Collaborative Care Management',
          es: 'Gestión colaborativa de la atención',
        },
      },
      {
        name: 'Care Coordination',
        translations: {
          en: 'Care Coordination',
          es: 'Coordinación de Atención',
        },
      },
      {
        name: 'CCRPM',
        translations: {
          en: 'CCRPM',
          es: 'CCRPM',
        },
      },
      {
        name: 'Hospital Discharge/Transition of Care',
        translations: {
          en: 'Hospital Discharge/Transition of Care',
          es: 'Alta hospitalaria/Transición de la atención',
        },
      },
      {
        name: 'Care Manager',
        translations: {
          en: 'Care Manager',
          es: 'Gerente de cuidado',
        },
      },
    ],
    name: 'Medical visit',
    translations: {
      en: 'Medical visit',
      es: 'Visita medica',
    },
  },
  {
    children: [
      {
        children: [
          {
            name: 'Individual',
            translations: {
              en: 'Individual',
              es: 'Individual',
            },
          },
          {
            name: 'Couples',
            translations: {
              en: 'Couples',
              es: 'Parejas',
            },
          },
          {
            name: 'Family',
            translations: {
              en: 'Family',
              es: 'Familia',
            },
          },
          {
            name: 'Group',
            translations: {
              en: 'Group',
              es: 'Grupo',
            },
          },
        ],
        name: 'Psychotherapy',
        translations: {
          en: 'Psychotherapy',
          es: 'Psicoterapia',
        },
      },
      {
        name: 'Psychiatry',
        translations: {
          en: 'Psychiatry',
          es: 'Psiquiatría',
        },
      },
      {
        name: 'HEDIS/Care Gap',
        translations: {
          en: 'HEDIS/Care Gap',
          es: 'HEDIS/brecha de atención',
        },
      },
      {
        name: 'Collaborative Care Management',
        translations: {
          en: 'Collaborative Care Management',
          es: 'Gestión colaborativa de la atención',
        },
      },
      {
        name: 'Hospital Discharge/Transition of Care',
        translations: {
          en: 'Hospital Discharge/Transition of Care',
          es: 'Alta hospitalaria/Transición de la atención',
        },
      },
      {
        name: 'Care Manager',
        translations: {
          en: 'Care Manager',
          es: 'Gerente de cuidado',
        },
      },
    ],
    name: 'Mental / BH visit',
    translations: {
      en: 'Mental / BH visit',
      es: 'Visita mental/BH',
    },
  },
];
